import React from 'react';
import SequencesWrapper from './Loadable';
import Sequence from './Sequence/Loadable';
import { PageTrackerWrapper } from 'queries/user/track';
import FicheDePrep from './Sequence/FicheDePrep/Loadable';
import StandaloneFicheDePrep from './StandaloneFicheDePrep/Loadable';
import ShareAccept from './ShareAccept/Loadable';
import { FolderContentWrapper } from './FolderContent';
import { Home } from './Home';
import { NewSequenceStart } from './New/NewSequenceStart';
import { NewFdpStart } from './StandaloneFicheDePrep/New/NewFdpStart';
import New from './New/Loadable';
import { SequenceTemplatePicker } from './New/ModelePicker';
import { SequencePreview, SequencePreviewWrapper } from './Preview';
import { TemplatePicker as FdpTemplatePicker } from './StandaloneFicheDePrep/New/TemplatePicker';

export const FicheDePrepRoutes = {
  path: 'fiches-de-prep',
  element: <SequencesWrapper />,
  children: [
    { index: true, element: <Home /> },
    {
      path: ':ficheDePrepId',
      element: (
        <PageTrackerWrapper title="Fiches de prep indépendante">
          <StandaloneFicheDePrep />
        </PageTrackerWrapper>
      ),
    },
  ],
};

// Separate route for template picker without sidebar
export const FicheDePrepNewRoutes = {
  path: 'fiches-de-prep/new',
  element: <SequencesWrapper hideSidebar />,
  children: [
    { index: true, element: <NewFdpStart /> },
    {
      path: 'with-template',
      element: (
        <PageTrackerWrapper title="Fiches de prep - nouvelle - modèle">
          <FdpTemplatePicker />
        </PageTrackerWrapper>
      ),
    },
  ],
};

export const SequenceRoutes = {
  path: 'sequences',
  element: <SequencesWrapper />,
  children: [
    { index: true, element: <Home /> },
    {
      path: 'folders/:folderId',
      element: <FolderContentWrapper />,
    },
    {
      path: 'new',
      element: <New />,
      children: [
        {
          index: true,
          element: (
            <PageTrackerWrapper title="Séquence - nouvelle - vide ou modèles">
              <NewSequenceStart />,
            </PageTrackerWrapper>
          ),
        },
        {
          path: 'with-template',
          element: (
            <PageTrackerWrapper title="Séquence - nouvelle - modèle">
              <SequenceTemplatePicker />
            </PageTrackerWrapper>
          ),
        },
      ],
    },
    {
      path: ':sequenceId',
      children: [
        {
          index: true,
          element: <Sequence />,
        },
        {
          path: 'fiches-de-prep/:ficheDePrepId',
          element: (
            <PageTrackerWrapper title="Fiches de prep">
              <FicheDePrep />
            </PageTrackerWrapper>
          ),
        },
        {
          path: 'share/accept',
          element: <ShareAccept />,
        },
      ],
    },
  ],
};

export const SequencePreviewRoutes = {
  path: 'sequences/:sequenceId',
  element: <SequencePreviewWrapper />,
  children: [
    {
      path: 'preview',
      element: (
        <PageTrackerWrapper title="Séquence - preview">
          <SequencePreview />
        </PageTrackerWrapper>
      ),
    },
    {
      path: 'fiches-de-prep/:ficheDePrepId/preview',
      element: (
        <PageTrackerWrapper title="Fiches de prep - preview">
          <SequencePreview />
        </PageTrackerWrapper>
      ),
    },
  ],
};
